import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import AddSlotPopup from '../../../components/Popups/AddSlotPopup/AddSlotPopup';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getParticularUser, mentorData } from '../../../reducer/mentorSlice';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import moment from 'moment';

function MnMenteeProfile() {

    const [TabSlotProfile, setTabSlotProfile] = useState(1);

    const { isFetching, isSuccess, isError, errorMessage, particularUser } = useSelector(mentorData);

    const { userId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //Get Months difference
    const getDiff = (param) => {
        const today = moment().month();
        const date = moment(param).month();
        return today - date;
    }

    useEffect(() => {
        dispatch(getParticularUser({user: "mentee", userId}));
    },[])

    return (
        <>
        {isFetching && <PageLoader />}
        <section>
            <div className="DashboardWrapper">
                <div className='pathlinkwrapper flex gap-10'>
                    <img src='assets/img/usericons.png' alt="" />
                    <p className='text2' onClick={() => navigate("/mentor/call-records")}>Call Records</p>
                    <img src="/assets/img/arrowright.png" alt="" />
                    <p className='text2'>Mentee Profile</p>
                </div>

                <div className="headingprofilewrap mt-30">
                    <h2 className='heading-2'>Profile Overview</h2>
                    <p className='text3 mt-5'>Joined {getDiff(particularUser?.createdAt)} month{getDiff(particularUser?.createdAt) > 1 ? 's' : ''} ago</p>
                </div>

                <div className="flex-col Allcardboxwrapper mt-30">
                    <div className="profilewrapper w-100 ">
                        <div className="flex Adprofiledatawrapper">
                            <div className='Imageboxall'>
                                <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                            </div>
                            <div className="AdProfileDetailsarea">
                                <div className="headingwrap">
                                    <div className="headingorg flex gap-10">
                                        <h2 className='heading-2'>{particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                        {particularUser?.linkedin && <a href={particularUser?.linkedin.slice(0,4) === "http" ? particularUser?.linkedin : "https://" + particularUser?.linkedin} className='linkedintext' target='_blank' rel='noreferrer'>
                                            <span className='flex gap-2'>
                                                Linkedin
                                                <img src="/assets/img/send.png" alt="" />
                                            </span>
                                        </a>}
                                    </div>
                                    <div className="AdPsnlDetailsMentors mt-10">
                                        <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/usermentor.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.profession?.designation ? particularUser?.profession?.designation === "student" ? 'Student' : 'Working Professional' : "---"}</p>
                                        </div>
                                        <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/emailprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                        </div>
                                        <div className="AdMentorSubDetails f-items-center">
                                            <span className="flex-center">
                                                <img src="/assets/img/contact/callprofile.png" alt="" />
                                            </span>
                                            <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                    <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Number of Calls'} img={"/assets/img/yellowcall.png"} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="AdMenusTabWrapper w-100 mt-40">
                        <ul className='flex gap-30 items-center'>
                            <li onClick={() => setTabSlotProfile(1)} className={TabSlotProfile === 1 && 'active'}>Profile Details</li>
                        </ul>
                    </div>

                </div>

            </div>

            <Profiledetails isActiveTab={TabSlotProfile === 1 && 'active'} data={particularUser} />

        </section>
        </>
    )
}

export default MnMenteeProfile